module.exports = __webpack_public_path__ + "img/Jump Casting26.15142860.jpg";